/**
 * Edit product saves a draft quietly on step changes and after Remove. Edits are counted, not flagged: a
 * save only marks as saved what it actually sent, so an edit (or a Remove) made while a save is in flight
 * is saved by the next one. A save asked for while busy or while photos upload waits ("pending").
 */
export type QuietDecision = "skip" | "wait" | "save";

export class QuietSaveGate {
  private edits = 0;
  private saved = 0;
  private sending = 0;
  pending = false;

  mark(): void {
    this.edits += 1;
  }

  /** Only drafts save quietly; nothing unsaved is a skip; busy or uploads in flight wait. */
  decide(opts: { isDraft: boolean; busy: boolean; mediaInFlight: number }): QuietDecision {
    if (!opts.isDraft || this.edits === this.saved) return "skip";
    if (opts.busy || opts.mediaInFlight > 0) {
      this.pending = true;
      return "wait";
    }
    this.pending = false;
    this.sending = this.edits;
    return "save";
  }

  /** The quiet save succeeded: everything up to what it sent is saved. */
  sent(): void {
    this.saved = Math.max(this.saved, this.sending);
  }
}
